import * as Yup from 'yup';
import { Section } from '@models';
import { Team } from '@models';

export function useValidationSchema() {
  return Yup.object<Team>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    section: Yup.mixed<Section>().nullable().required('Povinné pole'),
  }) as Yup.Schema<Team>;
}
